import { render, staticRenderFns } from "./AlertaAvisoValidacaoSaldo.vue?vue&type=template&id=5b89939b&scoped=true"
import script from "./AlertaAvisoValidacaoSaldo.vue?vue&type=script&lang=js"
export * from "./AlertaAvisoValidacaoSaldo.vue?vue&type=script&lang=js"
import style0 from "./AlertaAvisoValidacaoSaldo.vue?vue&type=style&index=0&id=5b89939b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89939b",
  null
  
)

export default component.exports